module.exports = __webpack_public_path__ + "static/img/login_bg.bf8e1e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/login_bg.jpg
// module id = xzWd
// module chunks = 6